import ReloadButton from 'components/elements/buttons/ReloadButton'
import ErrorIcon from 'components/elements/icons/ErrorIcon'
import MainTemplate from 'components/templates/MainTemplate'
import React from 'react'
import { switchValue } from 'utils/commonUtils'

/**
 * QN-016: 共通エラー画面
 */
const Error: React.FC<ErrorPageProps> = (props: ErrorPageProps) => {
  const { errorCode } = props

  const description = switchValue(
    {
      UnsupportedProductKbnCd:
        '状況を詳しくお伺いしたいため、\n下記ヘルプボタンよりお電話くださいますようお願いします。',
    },
    errorCode,
    '画面を再読み込みしても表示されない時はオペレーターへご連絡ください。'
  )

  return (
    <MainTemplate
      title={'うまく表示できません'}
      icon={<ErrorIcon />}
      description={description}
      content={<ReloadButton />}
      showContact
      background={'rgba(240, 240, 240, 1.0)'}
    />
  )
}

export type ErrorPageProps = {
  errorCode?: string
}

export default Error
